<script lang="ts">
    import type {ComponentSize} from 'shared/ui-widgets/types';
    import {noop} from 'rxjs';
    import {getFondNumberColor} from './utils';
    import {exists, ignoreUnusedProperties, isFunction} from 'shared/utils/custom-utils';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';

    export let chipSize: ComponentSize = 'xs';
    export let viewFondId: number;
    export let columnId: string; // TODO: change to fondId, make conversion in parent components

    let getChipRef: () => HTMLSpanElement;
    $: hoverable = isHoverable(getChipRef);

    const fieldSettings = {
        0: {
            'd1010': 2,
            'd1011': 2,
            'd1012': 2
        },
        1: {
            'd1111': 3,
            'd1112': 7,
            'd1120': 1
        },
        3: {
            'd1312': 7,
            'd1313': 7,
            'd1314': 7
        },
        6: {
            'd1610': 4,
            'd1620': 1
        },
        7: {
            'd1730': 7,
            'd1750': 2
        },
        8: {
            'd1810': 1,
            'd1860': 7
        },
        10: {
            'd2020': 1,
            'd2040': 4,
            'd2050': 7,
            'd2060': 9
        }
    };

    function getFondNumber(): number {
        if (!exists(viewFondId) || !exists(columnId)) {
            return 0;
        }

        const defaults = fieldSettings[0] ?? {};
        const viewSettings = fieldSettings[viewFondId] ?? {};

        columnId = columnId.replace(/\..*/, ''); // gets only main column id

        const allFieldFonds = {...defaults, ...viewSettings};
        return allFieldFonds[columnId] ?? 0;
    }

    function isHoverable(getChipRefFunc: () => HTMLSpanElement): boolean {
        if (!isFunction(getChipRefFunc)) {
            return false;
        }

        const chipRef = getChipRefFunc();
        if (!exists(chipRef)) {
            return false;
        }

        // When a Label is in the slot, there should be an anchor element in a inner span element - that's what we are checking for
        // And if it is exists, the chip is therefore hoverable and clickable
        const firstInnerChild = chipRef.firstElementChild?.firstElementChild;
        return firstInnerChild?.tagName.toLowerCase() === 'a';
    }

    // TODO: Handle hover and highlighting of connected chips
    const handleMouseEnter = () => {
        ignoreUnusedProperties();
    }

    const handleMouseLeave = () => {
        ignoreUnusedProperties();
    }

    const handleChipClick = () => {
        if (!hoverable) {
            return;
        }

        // TODO: Click on inner anchor
    }

    const fondNumber = getFondNumber();
    const textColor = getFondNumberColor(fondNumber, 12);
    const backgroundColor = getFondNumberColor(fondNumber, 85);
</script>

<span class="sutor-record-grid-fond-chip"
      role="link"
      tabindex="0"
      on:click={handleChipClick}
      on:keydown={noop}
      class:is-hoverable={hoverable}
      on:mouseenter={handleMouseEnter}
      on:mouseleave={handleMouseLeave}
      style:--chip-text-color="{textColor}"
      style:--chip-background-color="{backgroundColor}">

    <KpChipTag {chipSize} additionalClasses="record-grid-fond-tag" bind:getChipRef>
        <slot/>
    </KpChipTag>
</span>

<style lang="less">
    .sutor-record-grid-fond-chip.is-hoverable {
        display: flex;
        width: min-content;
        transition: opacity 0.3s ease-in-out;

        &:hover {
            opacity: 0.75;
        }
    }

    :global {
        .sutor-record-grid-fond-chip .record-grid-fond-tag {
            background-color: var(--chip-background-color);
            color: var(--chip-text-color);
            border: 1px solid rgba(0, 0, 0, 0.125);
            transition: border-color 0.3s ease-in-out;

            a {
                color: var(--chip-text-color);

                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
</style>